import { useTranslation } from 'react-i18next';
import CabeceraPagina from '../Compartido/CabeceraPagina.jsx';

const CabeceraAyuda = ({ ruta, textopol }) => {
    const { t } = useTranslation();

    return (
        <CabeceraPagina
            titulo={t("Ayuda")}
            eyebrow={t("Empresa")}
            imagen={textopol.imagen_cabecera ? ruta + "/" + textopol.imagen_cabecera : null}
        />
    );
}

export default CabeceraAyuda;
